const LandingStatuses = {
  CLOSED: 1,
  OPEN: 0,
  NEEDS_REWEIGHTING: 3,
  CORRECTED: 2
};

export default LandingStatuses;